import React, { Context } from "react";

export const ManaUIContext: Context<boolean> = React.createContext(false);

export const useManaUIActive = (): boolean => {
  return React.useContext(ManaUIContext);
};
